/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  CfiCustomFindingCreateRequest,
  CfiFinding,
  CfiFindingEdit,
  CfiReport,
  CfiReportsReportRetrieveParams,
  PatchedCfiFindingEditRequest,
  PatchedCfiReportEditRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type cfiFindingsRetrieveResponse200 = {
  data: CfiFinding
  status: 200
}

export type cfiFindingsRetrieveResponseSuccess = (cfiFindingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type cfiFindingsRetrieveResponse = (cfiFindingsRetrieveResponseSuccess)

export const getCfiFindingsRetrieveUrl = (id: string,) => {




  return `/api/v1/cfi/findings/${id}/`
}

/**
 * Consultant edit endpoint for a single CFI finding.
 *
 * PATCH /api/v1/cfi/findings/{pk}/
 *     Body: any subset of consultant_rating, consultant_rationale,
 *     consultant_recommended_action, agreed_with_agent, excluded_from_report.
 *
 * Status gate: only edits when the parent report is `awaiting_review`.
 * Auth: IsConsultantForContract via the resolved contract.
 */
export const cfiFindingsRetrieve = async (id: string, options?: RequestInit): Promise<cfiFindingsRetrieveResponse> => {

  return customFetch<cfiFindingsRetrieveResponse>(getCfiFindingsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type cfiFindingsPartialUpdateResponse200 = {
  data: CfiFindingEdit
  status: 200
}

export type cfiFindingsPartialUpdateResponseSuccess = (cfiFindingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type cfiFindingsPartialUpdateResponse = (cfiFindingsPartialUpdateResponseSuccess)

export const getCfiFindingsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/cfi/findings/${id}/`
}

/**
 * Consultant edit endpoint for a single CFI finding.
 *
 * PATCH /api/v1/cfi/findings/{pk}/
 *     Body: any subset of consultant_rating, consultant_rationale,
 *     consultant_recommended_action, agreed_with_agent, excluded_from_report.
 *
 * Status gate: only edits when the parent report is `awaiting_review`.
 * Auth: IsConsultantForContract via the resolved contract.
 */
export const cfiFindingsPartialUpdate = async (id: string,
    patchedCfiFindingEditRequest?: PatchedCfiFindingEditRequest, options?: RequestInit): Promise<cfiFindingsPartialUpdateResponse> => {

  return customFetch<cfiFindingsPartialUpdateResponse>(getCfiFindingsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCfiFindingEditRequest)
  }
);}


export type cfiReportsPartialUpdateResponse200 = {
  data: CfiReport
  status: 200
}

export type cfiReportsPartialUpdateResponseSuccess = (cfiReportsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type cfiReportsPartialUpdateResponse = (cfiReportsPartialUpdateResponseSuccess)

export const getCfiReportsPartialUpdateUrl = (id: string,) => {




  return `/api/v1/cfi/reports/${id}/`
}

/**
 * PATCH /api/v1/cfi/reports/{pk}/ — edit report-level narrative.
 *
 * Writable: consultant_scope_summary, consultant_next_steps. Only while the
 * report is awaiting_review.
 */
export const cfiReportsPartialUpdate = async (id: string,
    patchedCfiReportEditRequest?: PatchedCfiReportEditRequest, options?: RequestInit): Promise<cfiReportsPartialUpdateResponse> => {

  return customFetch<cfiReportsPartialUpdateResponse>(getCfiReportsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCfiReportEditRequest)
  }
);}


export type cfiReportsFindingsCreateResponse201 = {
  data: CfiFinding
  status: 201
}

export type cfiReportsFindingsCreateResponseSuccess = (cfiReportsFindingsCreateResponse201) & {
  headers: Headers;
};
;

export type cfiReportsFindingsCreateResponse = (cfiReportsFindingsCreateResponseSuccess)

export const getCfiReportsFindingsCreateUrl = (id: string,) => {




  return `/api/v1/cfi/reports/${id}/findings/`
}

/**
 * POST /api/v1/cfi/reports/{pk}/findings/
 *
 * Lets a consultant author a custom finding while a report is in review.
 * Body: {provisionLabel, rating, rationale, note?}. The new row is recorded
 * as `source=CONSULTANT_CUSTOM` with `consultant_added_by=request.user`.
 */
export const cfiReportsFindingsCreate = async (id: string,
    cfiCustomFindingCreateRequest: CfiCustomFindingCreateRequest, options?: RequestInit): Promise<cfiReportsFindingsCreateResponse> => {

  return customFetch<cfiReportsFindingsCreateResponse>(getCfiReportsFindingsCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cfiCustomFindingCreateRequest)
  }
);}


export type cfiReportsPublishCreateResponse200 = {
  data: CfiReport
  status: 200
}

export type cfiReportsPublishCreateResponseSuccess = (cfiReportsPublishCreateResponse200) & {
  headers: Headers;
};
;

export type cfiReportsPublishCreateResponse = (cfiReportsPublishCreateResponseSuccess)

export const getCfiReportsPublishCreateUrl = (id: string,) => {




  return `/api/v1/cfi/reports/${id}/publish/`
}

/**
 * POST /api/v1/cfi/reports/{pk}/publish/
 *
 * Publishes a report straight from review — there is no separate approve step.
 * Publishing derives consultant agreement, recomputes the aggregate, marks the
 * report PUBLISHED (superseding any prior published report), and schedules
 * precedent embedding (see ``main.lib.cfi.publish.publish_report``). The report
 * is rendered live as HTML on demand (browser print-to-PDF), so publishing only
 * flips status and records who/when — it does not freeze a PDF attachment.
 */
export const cfiReportsPublishCreate = async (id: string, options?: RequestInit): Promise<cfiReportsPublishCreateResponse> => {

  return customFetch<cfiReportsPublishCreateResponse>(getCfiReportsPublishCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type cfiReportsReopenCreateResponse200 = {
  data: CfiReport
  status: 200
}

export type cfiReportsReopenCreateResponseSuccess = (cfiReportsReopenCreateResponse200) & {
  headers: Headers;
};
;

export type cfiReportsReopenCreateResponse = (cfiReportsReopenCreateResponseSuccess)

export const getCfiReportsReopenCreateUrl = (id: string,) => {




  return `/api/v1/cfi/reports/${id}/reopen/`
}

/**
 * POST /api/v1/cfi/reports/{pk}/reopen/
 */
export const cfiReportsReopenCreate = async (id: string, options?: RequestInit): Promise<cfiReportsReopenCreateResponse> => {

  return customFetch<cfiReportsReopenCreateResponse>(getCfiReportsReopenCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


export type cfiReportsReportRetrieveResponse200 = {
  data: string
  status: 200
}

export type cfiReportsReportRetrieveResponseSuccess = (cfiReportsReportRetrieveResponse200) & {
  headers: Headers;
};
;

export type cfiReportsReportRetrieveResponse = (cfiReportsReportRetrieveResponseSuccess)

export const getCfiReportsReportRetrieveUrl = (id: string,
    params?: CfiReportsReportRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/cfi/reports/${id}/report/?${stringifiedParams}` : `/api/v1/cfi/reports/${id}/report/`
}

/**
 * GET /api/v1/cfi/reports/{pk}/report/
 *
 * Renders the owner-facing report live as a standalone HTML page (the client
 * saves a PDF via the browser's print dialog). Two access modes:
 *
 * - ?preview=true : consultant-only render of a report under review.
 * - (no query)    : any contract viewer, PUBLISHED reports only.
 *
 * There is no stored snapshot — the HTML always reflects current report data.
 */
export const cfiReportsReportRetrieve = async (id: string,
    params?: CfiReportsReportRetrieveParams, options?: RequestInit): Promise<cfiReportsReportRetrieveResponse> => {

  return customFetch<cfiReportsReportRetrieveResponse>(getCfiReportsReportRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}


